import React from "react";
import { default as WListItemAvatar } from "@mui/material/ListItemAvatar";

function ListItemAvatar(props) {
  return <WListItemAvatar {...props} />;
}

export default ListItemAvatar;
